import styled from 'styled-components';
import { IRadio2Props } from '../../../types/formTypes';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Radio = styled.div<Pick<IRadio2Props, 'error' | 'darkMode' | 'disabled' | 'blackBox'>>`
  position: absolute;
  top: 1px;
  left: 0;
  z-index: 1;
  box-sizing: border-box;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${({ error, darkMode, disabled }) => {
    if (error !== undefined) return '1px solid var(--error-color-state)';
    if (disabled) return '1px solid var(--base-color-midgrey)';
    if (darkMode) return '1px solid var(--base-color-white)';
    return '1px solid var(--base-color-black)';
  }};
  background-color: ${({ disabled, darkMode }) => {
    if (disabled) return 'var(--base-color-lightgrey)';
    if (darkMode) return 'var(--base-color-white)';
    return ' var(--base-color-white)';
  }};
  color: ${({ disabled, blackBox, darkMode }) => {
    if (disabled) return 'var(--base-color-midgrey)';
    if (darkMode) return 'var(--base-color-black)';
    if (blackBox) return 'var(--base-color-white)';
    return ' var(--base-color-black)';
  }};
`;

export const TickboxLabel = styled.label<Pick<IRadio2Props, 'darkMode' | 'blackBox'>>`
  position: relative;
  padding-left: 32px;
  input[type='radio'] {
    width: 1px;
    height: 1px;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 0;
    &:checked + ${Radio} {
      background-color: ${({ blackBox, darkMode }) => {
        if (darkMode) return 'var(--base-color-white)';
        if (blackBox) return 'var(--base-color-black)';
        return ' var(--base-color-white)';
      }};
    }
    &:focus + ${Radio} {
      outline: ${({ darkMode }) => {
        if (darkMode) return '4px solid var(--base-color-lemonchiffon)';
        return '3px solid var(--base-color-lapislazuli)';
      }};
    }
  }
`;

export const RadioIcon = styled.div`
  display: none;
  color: inherit;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: currentColor;
  input[type='radio']:checked + ${Radio} & {
    display: block;
  }
`;

export const TextLabel = styled.div<Pick<IRadio2Props, 'darkMode' | 'disabled'>>`
  color: ${({ darkMode, disabled }) => {
    if (darkMode && disabled) return 'var(--base-color-lightgrey)';
    if (darkMode) return 'var(--base-color-white)';
    if (disabled) return 'var(--base-color-darkgrey)';
    return 'var(--base-color-black)';
  }};
`;

export const ErrorLabel = styled.div<Pick<IRadio2Props, 'darkMode'>>`
  margin-top: 20px;
  color: ${({ darkMode }) => {
    if (darkMode) return 'var(--base-color-white)';
    return 'var(--base-color-errorstate)';
  }};
`;
